import * as React from "react";
import { FC } from "react";

import {
    ConfirmMiniModal,
    MiniModalButtonsDirection,
} from "../../../Engine/Form/CustomizationContexts/HelperFunctionContext/UIUtil/ConfirmMiniModal/ConfirmMiniModal";

const defaultMessages = {
    text: "Удалить все данные в выбранной части отчета?",
    headerText: "Подтверждение",
    confirmButtonText: "Удалить",
    discardButtonText: "Отмена",
};

interface ConfirmDeletionModalProps {
    text?: string;
    headerText?: string;
    confirmButtonText?: string;
    discardButtonText?: string;
    onConfirm: () => void;
    onDiscard: () => void;
    width?: string;
    buttonsDirection?: MiniModalButtonsDirection;
}

export const ConfirmDeletionModal: FC<ConfirmDeletionModalProps> = ({
    onConfirm,
    onDiscard,
    text = defaultMessages.text,
    headerText = defaultMessages.headerText,
    confirmButtonText = defaultMessages.confirmButtonText,
    discardButtonText = defaultMessages.discardButtonText,
    width,
    buttonsDirection,
}) => (
    <ConfirmMiniModal
        text={text}
        headerText={headerText}
        confirmButtonText={confirmButtonText}
        discardButtonText={discardButtonText}
        onConfirm={onConfirm}
        onDiscard={onDiscard}
        iconName={"TrashCanIcon"}
        width={width}
        buttonsDirection={buttonsDirection}
    />
);
